import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 693 693"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("g", {
      fill: "none",
      "fill-rule": "evenodd"
    }, [
      _createElementVNode("path", {
        fill: "currentColor",
        d: "M346.5 693c114.278 0 215.635-55.322 278.75-140.645C667.826 494.798 693 423.589 693 346.5 693 155.133 537.867 0 346.5 0S0 155.133 0 346.5 155.133 693 346.5 693"
      }),
      _createElementVNode("path", {
        fill: "#FFF",
        stroke: "#979797",
        d: "M193.733 191.003v311.26h67.514v-199.64L355.5 440.01l88.129-137.388v199.64h67.432v-311.26h-80.169L355.5 319.483l-77.246-128.48z"
      })
    ], -1)
  ])))
}
export default { render: render }